// Lazy Firestore for visitor-path code (never import the SDK statically there).
// Usage: const { db, doc, getDoc } = await loadFirestore()
// First call downloads and caches; failures aren't cached, so the next call retries.
let cachedFirestore = null

export function loadFirestore() {
  if (!cachedFirestore) {
    cachedFirestore = Promise.all([
      import('@/firebaseDb'),
      import('firebase/firestore')
    ]).then(([{ db }, sdk]) => ({ ...sdk, db }))
    cachedFirestore.catch(() => { cachedFirestore = null })
  }
  return cachedFirestore
}
